export const weatherLogColumns: any[] = [
  {
    field: 'status',
    title: '',
    filter: 'icon',
    locked: true,
    width: 50,
    minWidth: 50
  },
  {
    field: 'timeShow',
    title: 'Time',
    filter: 'text',
    locked: true,
    width: 100,
    minWidth: 100
  },
  {
    field: 'weatherWindow',
    mandatory: 'weatherWindowMandatory',
    title: 'Weather Window (h)',
    filter: 'numeric',
    allowNegative: false,
    width: 160
  },
  {
    field: 'windDirection',
    mandatory: 'windDirectionMandatory',
    title: 'Wind Direction (°T)',
    filter: 'numeric',
    allowNegative: false,
    width: 150
  },
  {
    field: 'windSpeedRecordedAt',
    mandatory: 'windSpeedRecordedAtMandatory',
    title: 'Wind Speed Recorded At (m)',
    filter: 'numeric',
    allowNegative: true,
    width: 210
  },
  {
    field: 'windSpeed',
    mandatory: 'windSpeedMandatory',
    title: 'Wind Speed (m/s)',
    filter: 'numeric',
    allowNegative: false,
    width: 150
  },
  {
    field: 'windSpeed2RecordedAt',
    mandatory: 'windSpeed2RecordedAtMandatory',
    title: 'Wind Speed 2 Recorded At (m)',
    filter: 'numeric',
    allowNegative: true,
    width: 220
  },
  {
    field: 'windSpeed2',
    mandatory: 'windSpeed2Mandatory',
    title: 'Wind Speed 2 (m/s)',
    filter: 'numeric',
    allowNegative: false,
    width: 150
  },
  {
    field: 'windGustRecordedAt',
    mandatory: 'windGustRecordedAtMandatory',
    title: 'Wind Gust Recorded At (m)',
    filter: 'numeric',
    allowNegative: true,
    width: 210
  },
  {
    field: 'windGust',
    mandatory: 'windGustMandatory',
    title: 'Wind Gust (m/s)',
    filter: 'numeric',
    allowNegative: false,
    width: 150
  },
  {
    field: 'windGust2RecordedAt',
    mandatory: 'windGust2RecordedAtMandatory',
    title: 'Wind Gust 2 Recorded At (m)',
    filter: 'numeric',
    allowNegative: true,
    width: 220
  },
  {
    field: 'windGust2',
    mandatory: 'windGust2Mandatory',
    title: 'Wind Gust 2 (m/s)',
    filter: 'numeric',
    allowNegative: false,
    width: 150
  },
  {
    field: 'averageWindSpeedRecordedAt',
    mandatory: 'averageWindSpeedRecordedAtMandatory',
    title: 'Average Wind Speed Recorded At (m)',
    filter: 'numeric',
    allowNegative: true,
    width: 260
  },
  {
    field: 'averageWindSpeed',
    mandatory: 'averageWindSpeedMandatory',
    title: 'Average Wind Speed (m/s)',
    filter: 'numeric',
    allowNegative: false,
    width: 200
  },
  {
    field: 'averageWindSpeed2RecordedAt',
    mandatory: 'averageWindSpeed2RecordedAtMandatory',
    title: 'Average Wind Speed 2 Recorded At (m)',
    filter: 'numeric',
    allowNegative: true,
    width: 275
  },
  {
    field: 'averageWindSpeed2',
    mandatory: 'averageWindSpeed2Mandatory',
    title: 'Average Wind Speed 2 (m/s)',
    filter: 'numeric',
    allowNegative: false,
    width: 150
  },
  {
    field: 'visibility',
    mandatory: 'visibilityMandatory',
    title: 'Visibility (m)',
    filter: 'numeric',
    allowNegative: false,
    width: 150
  },
  {
    field: 'significantWaveHeight',
    mandatory: 'significantWaveHeightMandatory',
    title: 'Significant Wave Height (m)',
    filter: 'numeric',
    allowNegative: false,
    width: 200
  },
  {
    field: 'wavePeriod',
    mandatory: 'wavePeriodMandatory',
    title: 'Wave Period (s)',
    filter: 'numeric',
    allowNegative: false,
    width: 150
  },
  {
    field: 'waveDirection',
    mandatory: 'waveDirectionMandatory',
    title: 'Wave Direction (°T)',
    filter: 'numeric',
    width: 150
  },
  {
    field: 'tidalRate',
    mandatory: 'tidalRateMandatory',
    title: 'Tidal Rate (m/s)',
    filter: 'numeric',
    allowNegative: false,
    width: 150
  },
  {
    field: 'tidalSet',
    mandatory: 'tidalSetMandatory',
    title: 'Tidal Set (°T)',
    filter: 'numeric',
    width: 150
  },
  {
    field: 'airTemperature',
    mandatory: 'airTemperatureMandatory',
    title: 'Air Temperature (°C)',
    filter: 'numeric',
    allowNegative: true,
    width: 160
  },
  {
    field: 'seaTemperature',
    mandatory: 'seaTemperatureMandatory',
    title: 'Sea Temperature (°C)',
    filter: 'numeric',
    allowNegative: true,
    width: 170
  },
  {
    field: 'precipitationDetailsId',
    mandatory: 'precipitationDetailsMandatory',
    title: 'Precipitation Details',
    filter: 'dropdown',
    width: 170
  },
  {
    field: 'iceThickness',
    mandatory: 'iceThicknessMandatory',
    title: 'Ice Thickness (mm)',
    filter: 'numeric',
    allowNegative: false,
    width: 150
  },
  {
    field: 'lightningObserved',
    mandatory: 'lightningObservedMandatory',
    title: 'Lightning Observed',
    filter: 'boolean',
    width: 150
  },
  {
    field: 'riskOfLightningId',
    mandatory: 'riskOfLightningMandatory',
    title: 'Risk of Lightning',
    filter: 'dropdown',
    width: 150
  },
];




// WEBPACK FOOTER //
// ./src/pages/weather-readings/weather-log-component/weather-log-component.config.ts